import React from 'react'
import HubBadge from 'components/sidebar/hubBadge'
import { userRoleOptions } from 'components/permissions/utils'
import { useProject } from 'hooks/useProject'
import { IAccessPolicy } from 'types'
import { UserRoles, AccessAttributeKinds, PROJECT } from 'app-constants'
import { capitaliseFirstLetter } from 'helpers/utils'
import Select from 'components/select'
interface Props {
  policy?: IAccessPolicy
  onUpdatePolicy: (policy: IAccessPolicy, role: UserRoles) => void
  onCreatePolicy: (role: UserRoles, attributeKind: AccessAttributeKinds, attributeId?: string) => void
  excludedPermissionCategories?: UserRoles[]
}

const ProjectPermissions: React.FC<Props> = ({
  onUpdatePolicy,
  policy,
  onCreatePolicy,
  excludedPermissionCategories
}) => {
  const { project } = useProject()

  return (
    <div className="flex items-center cursor-pointer rounded-lg border-box select-none border border-divider transition-all p-6 min-h-[90px] mt-0 mb-2.5 mx-[5px]">
      <span className="mr-2.5">
        <HubBadge name={project.name} colour={project.primaryColour} textColour={project.fontColour} size={50} />
      </span>
      <div className="flex justify-center flex-col h-full">
        <div className="font-bold mb-[5px]">This {capitaliseFirstLetter(PROJECT)}</div>
        <div>Set permissions for all users in &apos;{project.name}&apos;</div>
      </div>
      <div className="ml-auto w-[130px]">
        <Select
          options={userRoleOptions
            .filter(
              (userRole) => !excludedPermissionCategories || !excludedPermissionCategories.includes(userRole.value)
            )
            .map((option) => ({
              value: String(option.value),
              label: option.label
            }))}
          optionsSelected={[
            String(
              policy
                ? excludedPermissionCategories && excludedPermissionCategories.includes(policy.role)
                  ? ''
                  : policy.role
                : -1
            )
          ]}
          onOptionClick={(option) => {
            const value = parseInt(option)
            if (policy) {
              onUpdatePolicy(policy, value)
            } else {
              onCreatePolicy(value, AccessAttributeKinds.PROJECT, project.publicId)
            }
          }}
          searchable={false}
        />
      </div>
    </div>
  )
}

export default ProjectPermissions
